var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps-wrap"},[_c('div',{staticClass:"steps-wrap-items"},[_vm._l((_vm.steps),function(item,index){return _c('div',{key:index,staticClass:"steps-wrap-dot",class:{
        'steps-wrap-dot-active': _vm.current >= item,
        'dot-l': index === 0
      },style:({
        left: _vm.portion * index + '%'
      }),attrs:{"data-value":item + 'x'},on:{"click":() => _vm.onSlide(index, item)}})}),_c('div',{staticClass:"steps-wrap-lined",style:({ width: _vm.activeSty })}),_c('div',{staticClass:"steps-wrap-dot-diy",style:({left: _vm.activeSty})})],2),_c('p',{staticClass:"steps-wrap-notice"},[_vm._v(" "+_vm._s(_vm.$t('features.stepNotice'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }